import { getCLS, getFID, getLCP, getTTFB, getFCP } from "web-vitals";
import { track } from "./analytics";

function reportCWV({ name, delta, id }) {
  const value = Math.round(name === "CLS" ? delta * 1000 : delta);
  track("Web Vitals", name, id, value);
}

export default function setupCWVTracking() {
  getCLS(reportCWV);
  getFID(reportCWV);
  getLCP(reportCWV);
  getTTFB(reportCWV);
  getFCP(reportCWV);
}
